<!--
 * @Descripttion: 
 * @version: 
 * @Author: mrh
 * @Date: 2020-07-28 09:29:22
 * @LastEditors: mrh
 * @LastEditTime: 2021-01-06 17:54:15
--> 
<template>
  <div
    class="divs"
    :class="{'cover':!$store.getters.ambientType}"
  >
    <div class="tip">
      <span>提示:系统没有您{{csType == 1 ? "居住" : "想要"}}的{{csType == 1 ? "社" : "校"}}区吗？您可以在当前页面申请开通{{csType == 1 ? "社" : "校"}}区</span>
    </div>
    <van-form
      validate-first
      @failed="onFailed"
      :show-error-message="false"
      scroll-to-error
      ref="submits"
      @submit="onSubmit"
      :show-error="showError"
    >
      <van-field
        v-model="communiyObj.areaIds"
        label="开通城市"
        :placeholder="`请选择${csType == 1 ? '社' : '校'}区城市`"
        readonly
        required
        right-icon="arrow"
        @click="showArea = true"
        :rules="[{ validator: asyncValidator, message: `请选择${csType == 1 ? '社' : '校'}区城市`, trigger:onSubmit }]"
      />
      <van-field
        v-model="communiyObj.areaBCIds"
        :label="`${csType == 1 ? '社' : '校'}区商圈`"
        :placeholder="`请选择${csType == 1 ? '社' : '校'}区商圈`"
        right-icon="arrow"
        @click="showList = true"
        readonly
        required
        :rules="[{ validator: asyncValidator, message: `请选择${csType == 1 ? '社' : '校'}区商圈`, trigger:onSubmit }]"
      />
      <van-field
        v-model="communiyObj.schoolName"
        :label="`${csType == 1 ? '社' : '校'}区类型`"
        :placeholder="`请选择${csType == 1 ? '社' : '校'}区类型`"
        right-icon="arrow"
        @click="showSchoolList = true;"
        readonly
        required
        :rules="[{ validator: asyncValidator, message: `请选择${csType == 1 ? '社' : '校'}区类型`, trigger:onSubmit }]"
        v-if="csType == 2"
      />
      <van-field
        v-model="communiyObj.communiytName"
        name="mobile"
        :label="`${csType == 1 ? '社' : '校'}区名称`"
        :placeholder="`请输入${csType == 1 ? '社' : '校'}区全称`"
        required
        :rules="[{ validator: asyncValidator, message: `请选择${csType == 1 ? '社' : '校'}区全称`, trigger:onSubmit }]"
      />
      <van-field
        v-model="communiyObj.address"
        label="详细地址"
        :placeholder="`请选择${csType == 1 ? '社' : '校'}区详情地址`"
        readonly
        required
        @click="goCheckAddress"
        right-icon="arrow"
        :rules="[{ validator: asyncValidator, message: `请选择${csType == 1 ? '社' : '校'}区详情地址`, trigger:onSubmit }]"
      />

      <!-- <van-field
      v-model="communiyObj.mobile"
      autosize
      label="联系方式"
      maxlength='11'
      placeholder="请输入您的联系方式"
      type="digit"
      rows="1"
      required
      :rules="[{ validator: asyncValidator, message: '请输入您的联系方式' }]"
    /> -->
      <div class="btns">
        <van-button
          round
          block
          type="info"
          native-type="button"
          @click="confirm()"
          color="#50BE4C"
        >提交申请</van-button>
      </div>
    </van-form>
    <div class="tipText">
      <span> 提示： </span>
      <!-- <span> 1.开通社区后您可在“个人中心 - 成为店长”申请成为社区店长。 </span> -->
      <span>
        <p>若已有{{csType == 1 ? "社" : "校"}}区与您申请{{csType == 1 ? "社" : "校"}}区信息不符，可以联系平台客服进行修改<a
            @click="dialPhone('0752-2162293')"
            style="color: #50BE4C"
          >0752-2162293</a></p>
      </span>
    </div>
    <!-- 选择城市弹窗 -->
    <van-popup
      v-model="showArea"
      :overlay="showArea"
      ref="popup"
      position="bottom"
      :style="{ height: '68%' }"
    >
      <van-area
        ref="area"
        :area-list="areaList"
        :value="areaId"
        visible-item-count="9"
        @confirm="checkArea"
        @cancel="showArea = false"
      />
    </van-popup>
    <!-- 校区类型弹窗 -->
    <van-popup
      v-model="showSchoolList"
      position="bottom"
    >
      <van-picker
        show-toolbar
        value-key="name"
        :columns="schoolList"
        @confirm="onConfirm"
        @cancel="showSchoolList = false"
      />
    </van-popup>
    <!-- 商圈弹窗 -->
    <van-popup
      v-model="showList"
      position="bottom"
      :style="{ height: '68%', overflow: 'hidden' }"
    >
      <!-- <div class="lists">
        <span @click="showList = false">取消</span>
        <span >确认</span>
      </div> -->
      <div class="listdiv">
        <p
          v-for="(item, index) in circleList"
          :key="index"
          class="adlists"
          :class="{ listcol: index == circleIndex }"
          @click="confirmList(item, index)"
        >
          <span>{{ item.areaCircleName }}</span>
        </p>
      </div>
      <!-- @click="getAreaCircle(item,index)" -->
    </van-popup>
  </div>
</template>

<script>
import {
  addCommunity,
  getBusinesscCircleList,
  searchCsList,
} from "@/api/join";
import areaLists from "@/utils/area.js";
export default {
  data() {
    return {
      communiyObj: {
        communiytName: "", //社区名
        areaIds: "", // 社区所在地区ID
        areaBCIds: "", // 地区商圈ID，传0则说明没有商圈
        address: "", // 详细地址
        // mobile: "", // 联系电话
        longitude: "", //经度
        latitude: "",
        schoolName: "", // 校区类型名称
      },
      showError: false,
      areaId: "", //区id
      areaBCId: "", //商圈id
      areaList: areaLists, //省市区list
      showArea: true, //是否展示省市区选择列表
      city: "", //城市名
      cityId: "", // 城市id
      circleList: [], // 附近商圈list
      showList: false,
      circleIndex: 0, // 附近商圈list的index
      lng: "", //经度
      lat: "", //纬度
      csType: 1, // 1社区，2校区
      schoolType: 0, // 校区类型id
      schoolList: [{
        id: 1,
        name: "幼儿园",
      }, {
        id: 2,
        name: "小学",
      }, {
        id: 3,
        name: "中学",
      }, {
        id: 4,
        name: "其他",
      }],
      showSchoolList: false
    };
  },
  mounted() {
    this.csType = this.$route.query.csType * 1 || 1;
    this.areaId =
      this.$store.getters.areaId == "-1"
        ? "441302"
        : this.$store.getters.areaId;
    // 选择省市区
    this.$refs.area.reset(this.areaId);
    this.showArea = false;
    //通过实例的getValues获取选中的列表
    let a = this.$refs.area.getValues();
    this.communiyObj.areaIds = `${a[0].name}/${a[1].name}/${a[2].name}`;
    this.city = a[1].name;
    this.cityId = a[1].code;
    this.getBusinesscCircleList(this.areaId);
  },
  methods: {
    onConfirm(value) {
      this.communiyObj.schoolName = value.name;
      this.schoolType = value.id;
      this.showSchoolList = false;
    },
    dialPhone(phone) {
      if (this.$store.getters.ambientType != 1) {
        window.location.href = 'tel:' + phone;
      } else {
        window.Android.dialPhone(phone);
      }
    },
    // 异步校验函数返回 Promise
    confirm() {
      this.clicks = true;
      this.$refs.submits.submit();
    },
    asyncValidator(val) {
      return new Promise((resolve) => {
        // this.$toast('校验保存中...')
        setTimeout(() => {
          this.$toast.clear();
          resolve(/\S/.test(val));
        }, 100);
      });
    },
    onSubmit() {
      searchCsList({
        position: {
          longitude: this.lng,
          latitude: this.lat,
        },
        cityId: this.cityId,//城市ID	
        keyword: this.communiyObj.communiytName,//社区关键字	
        page: {
          way: "0", // 0:不分页 1:分页
          index: "1", //请求页
          size: "20",//请求大小
        },
      }).then(res => {
        // 筛选列表是否有相同名称社/校区
        let list = res.content.list.filter(item => item.shopName === this.communiyObj.communiytName);
        if (list.length) {
          // 有相同名称社/校区 判断这个社/校区是否有店长
          this.$dialog.alert({
            message: `已存在该${this.csType == 1 ? "社" : "校"}区，无需新增`,
            confirmButtonText: "确定",
            confirmButtonColor: "#2DC660",
            cancelButtonText: "取消",
            cancelButtonColor: "#1D1D1D",
            showCancelButton: true,
          })
            .then(() => { });
        } else {
          // 没有相同名称社/校区 则直接新增
          let obj = this.communiyObj;
          obj.areaId = this.areaId;
          obj.areaBCId = this.areaBCId;
          obj.type = this.csType;
          obj.schoolType = this.schoolType;
          delete obj.areaIds;
          delete obj.areaBCIds;
          delete obj.schoolName;
          obj.longitude =
            this.lng != undefined ? this.lng : this.$store.getters.longitude;
          obj.latitude =
            this.lat != undefined ? this.lat : this.$store.getters.latitude;
          addCommunity(obj).then((res) => {
            // this.$toast("保存成功");
            if (res.appStatus.errorCode != 0) {
              return;
            }
            setTimeout(() => {
              this.$router.push("success");
            }, 1200);
          });
        }
      })
    },
    onFailed(errorInfo) {
      this.$toast(errorInfo.errors[0].message);
      this.showError = true;
    },
    checkArea(a) {
      this.showArea = false;
      this.communiyObj.areaIds = `${a[0].name}/${a[1].name}/${a[2].name}`;
      this.areaId = a[2].code;
      this.city = a[1].name;
      this.getBusinesscCircleList(a[2].code);
    },
    goCheckAddress() {
      this.$router.push({
        path: "/map",
        query: {
          city: this.city,
          lng: this.$store.getters.longitude,
          lat: this.$store.getters.latitude,
          type: 0
        },
      });
    },
    getAreaCircle(item, index) {
      this.circleIndex = index;
    },
    confirmList(el, index) {
      this.communiyObj.areaBCIds = el.areaCircleName;
      this.areaBCId = el.areaCircleId;
      this.circleIndex = index;
      this.showList = false;
    },
    getBusinesscCircleList(areaId) {
      getBusinesscCircleList({ areaId }).then((res) => {
        this.circleList = res.content.circleList;
      });
    },
  },
  activated() {
    this.communiyObj.address = this.$route.query.address == undefined ? "" : this.$route.query.address;
    this.lng = this.$route.query.lng;
    this.lat = this.$route.query.lat;
  },
  beforeRouteEnter(to, from, next) {
    if (to.query.csType) {
      to.meta.title = `开通${to.query.csType == 1 ? "社" : "校"}区`;
      document.title = to.meta.title;
    }
    next();
  },
};
</script>
<style lang="scss" scoped>
.btns {
  width: 355px;
  position: fixed;
  bottom: 10px;
  left: 0;
  right: 0;
  margin: 0 auto;
  .van-button {
    height: 40px;
    line-height: 40px;
    .van-button__text {
      font-size: 16px;
    }
  }
}
.divs {
  background: #f5f5f5;
  height: calc(100% - 44px);
}
.van-cell {
  line-height: 30px;
  /deep/.van-field__label {
    width: 75px;
    margin: 0;
  }
}
.van-cell--required::before {
  font-weight: 800;
  color: #ff2727;
}
// .lists {
//   width: 100%;
//   height: 49px;
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   border-bottom: 1.04px solid #f4f4f4;
//   span {
//     width: 120px;
//     text-align: center;
//     font-size: 15px;
//     color: #333333;
//   }
// }
.listdiv {
  height: calc(100% - 49px);
  overflow: auto;
}
.listcol {
  position: relative;
  span {
    color: #ff1310 !important;
  }
  span::before {
    content: "";
    width: 4px;
    height: 29px;
    background: #ff3838;
    position: absolute;
    left: 0;
    top: 15.5px;
  }
}

.adlists {
  width: auto;
  padding: 0 20px;
  height: 60px;
  display: flex;
  align-items: center;
  span {
    font-size: 16px;
    color: #333333;
  }
}
.tipText {
  width: auto;
  margin: 10px 15px;
  span {
    font-size: 12px;
    color: #999;
    display: block;
    line-height: 18px;
  }
}
.tip {
  width: auto;
  height: 30px;
  padding: 0 15px;
  background: #ffe9d5;
  color: #333;
  font-size: 12px;
  line-height: 30px;
}
</style>